/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { SnackBarData, SnackbarInfoComponent, SnackBarService } from '@ui';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { hasLink } from '@ngxp/rest';
import { Subscription } from 'rxjs';
import { CommandActions } from './+state/command.actions';
import { CommandLinkRel } from './command.linkrel';
import { CommandResource } from './command.model';
import { hasCommandError } from './command.util';

@Injectable({ providedIn: 'root' })
export class CommandSnackbarService {
  private readonly snackBarService = inject(SnackBarService);
  private readonly store = inject(Store);

  public show(commandResource: CommandResource, message: string, revokeAble: boolean = false): void {
    if (hasCommandError(commandResource)) {
      this.snackBarService.showError(message);
      return;
    }

    const data: SnackBarData = { message, isRevokable: hasLink(commandResource, CommandLinkRel.REVOKE) };
    this.snackBarService.openFromComponent(SnackbarInfoComponent, { data });
    if (revokeAble) this.listenOnRevokeAction(commandResource);
  }

  listenOnRevokeAction(command: CommandResource): void {
    const subscription: Subscription = this.snackBarService.snackBarRef.onAction().subscribe(() => {
      this.store.dispatch(CommandActions.revokeCommand({ command }));
      this.snackBarService.closeSnackBar();
    });
    this.snackBarService.subscription.add(subscription);
  }
}
